/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import React, { useContext, useEffect, useState } from 'react';
import { CoreContext } from '../../context/CoreContext';
import { parseCategory } from '../../utils/parser';

import {
  SideMoreContainer,
  SideMoreClose,
  SideMoreCloseIcon,
  SideMoreHeader,
  SideMoreHeaderTitle,
  SideMoreHeaderText,
  SideMoreItem,
  SideMoreItemText,
} from './styled';

export default withFocusable({
  trackChildren: true,
  forgetLastFocusedChild: false,
})(function SideMore(props: Record<string, unknown>) {
  const { side, setSide, setMoreCategory } = useContext(CoreContext);

  const [active, setActive] = useState(0);

  const sideTabs = ((side as { tabs?: Record<string, unknown>[] })?.tabs ?? []) as Record<
    string,
    unknown
  >[];
  const options = sideTabs.length > 3 ? [...sideTabs].slice(3).map(parseCategory) : [];

  const action = (item: Record<string, unknown>) => {
    setSide(null);
    setMoreCategory(item);
  };

  return (side as { type?: string })?.type !== 'side-more' ? null : (
    <>
      <SideMoreContainer>
        <SideMoreClose
          onPress={() => setSide(null)}
          onEnterPress={() => setSide(null)}
          focusKey={`sidemore-close`}
        >
          <SideMoreCloseIcon />
        </SideMoreClose>
        <SideMoreHeader>
          <SideMoreHeaderTitle>Ver Mais</SideMoreHeaderTitle>
          <SideMoreHeaderText>Escolha um tema.</SideMoreHeaderText>
        </SideMoreHeader>
        {options?.map((item, key) => (
          <SideMoreItem
            key={key}
            focusKey={`sidemore-${key + 1}`}
            onPress={() => action(item)}
            onEnterPress={() => action(item)}
          >
            <SideMoreItemText>{item.title}</SideMoreItemText>
          </SideMoreItem>
        ))}
      </SideMoreContainer>
    </>
  );
});
